<script>
import XEUtils from 'xe-utils'

export default {
  data() {
    return {
      name: '开通应用',
      tenantList: [],
      platformList: [],
      appList: [],
      data: [],
      state: [
        {
          value: 'tenant',
          label: '企业'
        },
        {
          value: 'platform',
          label: '站台'
        }
      ],
      tenantId: -1,
      platformId: -1,
      loading: false,
    }
  },
  mounted() {
    this.tenantId = 906
    this.platformId = 5
    this.state = 'tenant'
    this.getTenantList()
    this.getPlatformList()
    this.getAppList()
  },
  methods: {

    getTenantList() {
      const params = {
        headers: {
          tenantId: this.tenantId,
          platformId: this.platformId
        }
      }
      this.$axios.get('/account/tenant/all', params).then(res => {
        this.tenantList = res.data.data
      }).catch(() => {
        this.tenantList = []
      })
    },
    getPlatformList() {
      const params = {
        headers: {
          tenantId: this.tenantId,
          platformId: this.platformId
        }
      }
      this.$axios.get('/account/platform/all', params).then(res => {
        this.platformList = res.data.data
      }).catch(() => {
        this.platformList = []
      })
    },
    getAppList() {
      const headers = {
        tenantId: this.tenantId,
        platformId: this.platformId
      }
      let params = {
        conditions: [],
        sorts: [],
        pageNum: 1,
        pageSize: 2000
      }
      this.$axios.post('/paas/app/list', params, { headers }).then((res) => {
        this.$axios.post('/paas/app/appInstalledWithExpiration', {}, { headers }).then((appRes) => {
          this.appList = XEUtils.orderBy(res.data.data.list, 'sort')
          let installedList = appRes.data.data
          for (let i = 0; i < this.appList.length; i++) {
            let item = this.appList[i]
            for (let c = 0; c < installedList.length; c++) {
              let installed = installedList[c]
              if (item.code === installed.code) {
                item['isInstall'] = true
                item['expirationTime'] = installed.expirationTime
              }
            }
          }
          this.getData()
        }).catch(() => {
          this.data = []
        })
      }).catch(() => {
        this.data = []
      })
    },
    getData() {
      if (this.state === 'platform') {
        this.data = this.appList.filter((item) => {
          return item.is_platform
        })
      } else {
        this.data = this.appList.filter((item) => {
          return !item.is_platform
        })
      }
      this.data = XEUtils.orderBy(this.data, [['isInstall', 'asc'], ['expirationTime', 'desc']])
    },
    setInstalled(item) {
      const headers = {
        tenantId: this.tenantId,
        platformId: this.platformId
      }
      this.$axios.post(`/paas/app/install/${item.id}`, {}, { headers }).then(() => {
        this.$message.success({
          showClose: true,
          message: `开通 ${item.name} 成功`
        })
        this.getAppList()
      }).catch(() => {
      })
    },
    setUnInstalled(item) {
      const headers = {
        tenantId: this.tenantId,
        platformId: this.platformId
      }
      this.$confirm(`确定关闭该应用吗？关闭该应用可能会导致数据错误`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$axios.post(`/paas/app/uninstall/${item.id}`, {}, { headers }).then(() => {
          this.$message.success({
            showClose: true,
            message: `关闭 ${item.name} 成功`
          })
          this.getAppList()
        }).catch(() => {
        })
      }).catch(() => {
      })
    }
  }
}
</script>

<template>
  <div style="padding: 20px; height: 100%; box-sizing: border-box">
    <div class="cf" style="padding:10px;">
      <div class="fl" style="display: flex;">
        <el-radio-group @change="getAppList()" size="mini" v-model="state">
          <el-radio-button label="tenant">企业</el-radio-button>
          <el-radio-button label="platform">站台</el-radio-button>
        </el-radio-group>
        <el-select placeholder="请选择企业" v-model="tenantId" filterable style="margin-left: 10px"
          @change="getAppList()" size="mini">
          <el-option v-for="item in tenantList" :value="item.id" :label="item.name" :key="item.id"></el-option>
        </el-select>
        <el-select placeholder="请选择站台" v-model="platformId" filterable style="margin-left: 10px"
          @change="getAppList()" size="mini">
          <el-option v-for="item in platformList" :value="item.id" :label="item.name" :key="item.id"></el-option>
        </el-select>
      </div>
      <div class="fr">
        <el-tooltip class="item" effect="dark" content="查询" placement="top">
          <el-button size="mini" @click="getAppList()" circle icon="el-icon-search">
          </el-button>
        </el-tooltip>
      </div>
    </div>
    <el-table :data="data" border size="small" style="width: 100%" height="80%" highlight-current-row>
      <template slot="empty">
        <el-empty></el-empty>
      </template>
      <el-table-column prop="name" label="应用名称" width="150" show-overflow-tooltip align="center"></el-table-column>
      <el-table-column prop="remark" label="简介" min-width="180" show-overflow-tooltip
        align="center"></el-table-column>
      <el-table-column prop="expirationTime" label="到期时间" width="180" show-overflow-tooltip
        align="center"></el-table-column>
      <el-table-column prop="is_platform" label="应用类型" width="180" show-overflow-tooltip
        align="center">
        <template v-slot="scope">
          <el-tag :type="scope.row.is_platform ? 'primary' : 'success'">
            {{ scope.row.is_platform ? '站台' : '企业' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column fixed="right" width="100" label="操作" align="center">
        <template v-slot="scope">
          <el-button size="small" @click.native="setInstalled(scope.row)" type="primary" v-if="!scope.row.isInstall">
            开通
          </el-button>
          <el-button size="small" @click.native="setUnInstalled(scope.row)" type="danger" v-if="scope.row.isInstall">
            关闭
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<style scoped>

</style>
